import React from 'react';
import { CardForm, formatCardNumber, formatExpiration } from './featureUi';

interface Props {
    card: CardForm;
    onChange: (card: CardForm) => void;
    errors: Record<string, string>;     // cardNumber, cardExpiration, cardCvv, cardName
    disabled?: boolean;
    idPrefix?: string;
    note?: string;                      // aviso bajo los campos
}

const DEFAULT_NOTE = 'Validamos la tarjeta con su banco sin hacer cargos. Solo guardamos los últimos 4 dígitos.';

/**
 * Datos de la tarjeta para la suscripción. El número no se guarda: el API lo valida con el emisor y guarda solo el
 * token del procesador y los últimos 4 dígitos.
 */
export const CardFields = ({ card, onChange, errors, disabled, idPrefix = 'card', note = DEFAULT_NOTE }: Props) => {
    const set = (field: keyof CardForm, value: string) => onChange({ ...card, [field]: value });
    const invalid = (key: string) => (errors[key] ? 'is-invalid' : '');
    const feedback = (key: string) => errors[key] && <div className="invalid-feedback">{errors[key]}</div>;

    return (
        <div className="row g-3">
            <div className="col-12">
                <label htmlFor={`${idPrefix}-number`} className="form-label small text-muted mb-1">Número de tarjeta</label>
                <div className="input-group has-validation">
                    <span className="input-group-text"><i className="bi bi-credit-card" /></span>
                    <input id={`${idPrefix}-number`} className={`form-control ${invalid('cardNumber')}`} inputMode="numeric" autoComplete="cc-number"
                        placeholder="0000 0000 0000 0000" value={card.number} disabled={disabled}
                        onChange={e => set('number', formatCardNumber(e.target.value))} />
                    {feedback('cardNumber')}
                </div>
            </div>
            <div className="col-12">
                <label htmlFor={`${idPrefix}-name`} className="form-label small text-muted mb-1">Nombre en la tarjeta</label>
                <input id={`${idPrefix}-name`} className={`form-control ${invalid('cardName')}`} maxLength={100} autoComplete="cc-name"
                    value={card.name} disabled={disabled} onChange={e => set('name', e.target.value)} />
                {feedback('cardName')}
            </div>
            <div className="col-6">
                <label htmlFor={`${idPrefix}-exp`} className="form-label small text-muted mb-1">Vencimiento</label>
                <input id={`${idPrefix}-exp`} className={`form-control ${invalid('cardExpiration')}`} inputMode="numeric" autoComplete="cc-exp"
                    placeholder="MM/AA" value={card.expiration} disabled={disabled}
                    onChange={e => set('expiration', formatExpiration(e.target.value))} />
                {feedback('cardExpiration')}
            </div>
            <div className="col-6">
                <label htmlFor={`${idPrefix}-cvv`} className="form-label small text-muted mb-1">CVV</label>
                <input id={`${idPrefix}-cvv`} type="password" className={`form-control ${invalid('cardCvv')}`} inputMode="numeric" autoComplete="cc-csc"
                    maxLength={4} value={card.cvv} disabled={disabled} onChange={e => set('cvv', e.target.value.replace(/\D/g, '').slice(0, 4))} />
                {feedback('cardCvv')}
            </div>
            <div className="col-12">
                <p className="small text-muted mb-0">
                    <i className="bi bi-shield-lock me-1" />
                    {note}
                </p>
            </div>
        </div>
    );
};

export default CardFields;
